import Logger from './logger';

export default function getCompositeLogger(loggers: Array<Logger>): Logger {
  return {
    info: (...args): void => loggers.forEach((logger) => logger.info(...args)),
    warn: (...args): void => loggers.forEach((logger) => logger.warn(...args)),
    error: (...args): void =>
      loggers.forEach((logger) => logger.error(...args)),
  } as Logger;
}
